/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {}
 */
export interface PresentationSearchRequest {
    /** The filter to apply to the search. */
    filter?: Truvity.PresentationFilter[];
    /** The sort order to apply to the search. */
    sort?: Truvity.PresentationSort[];
}
